import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const artisans = [{
  name: "Nicole Lang",
  role: "Lead Groomer",
  specialties: ["Certified", "Golden Retriever Lover", "Senior Care"],
  image: "https://barkbathmobile.com/wp-content/uploads/2026/03/ChatGPT-Image-Mar-30-2026-07_04_06-AM.png?v=vg9gcsyol7l",
  bio: "Jessica has a soft spot for Golden Retrievers and loves making every senior dog feel like a puppy again."
}, {
  name: "Meghan Leffler",
  role: "Styling Expert",
  specialties: ["Certified", "Doodle Specialist", "Skin Therapy"],
  image: "https://barkbathmobile.com/wp-content/uploads/2026/03/ChatGPT-Image-Mar-30-2026-06_59_48-AM.png?v=urp6v2gjo6q",
  bio: "David is our resident Doodle specialist and an expert in therapeutic skin treatments for sensitive pups."
}, {
  name: "Sophie Ross",
  role: "Creative Groomer",
  specialties: ["Certified", "Terrier Fanatic", "Puppy Expert"],
  image: "https://barkbathmobile.com/wp-content/uploads/2026/03/ChatGPT-Image-Mar-30-2026-07_22_20-AM.png?v=rzygedvdpad",
  bio: "Sophie loves the feisty personality of Terriers and specializes in making a puppy's first grooming a happy one."
}];
export default function MeetTheArtisans() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27389" id="meet-our-caring-professionals" className="bg-background overflow-hidden text-foreground !m-0 ![padding:40px_0px_40px_0px]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-4 tracking-tight">Meet Our Caring Grooming Professionals</h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-medium leading-relaxed">
            Our expert groomers bring the spa experience to your doorstep with love, patience, and professional care for every pup.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-12">
          {artisans.map((artisan, i) => <div key={artisan.name} data-index={i} className={`group flex flex-col transition-all duration-700 ease-out delay-[${i * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              {}
              <div className="relative w-full aspect-square overflow-hidden rounded-full border-4 border-secondary bg-muted mb-6 shadow-lg">
                <img src={artisan.image} alt={artisan.name} className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" />
                {}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500" />
              </div>

              {}
              <div className="flex flex-col items-center text-center">
                <h3 className="text-2xl font-sans font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                  {artisan.name}
                </h3>
                <p className="text-sm font-bold text-primary uppercase tracking-widest mb-3">
                  {artisan.role}
                </p>
                
                <div className="flex flex-wrap justify-center gap-2 mt-auto">
                  {artisan.specialties.map((specialty, idx) => <Badge key={idx} variant="secondary" className="bg-secondary/10 text-primary border border-secondary/20 hover:bg-secondary/20 px-3 py-1 rounded-full font-medium">
                      {specialty}
                    </Badge>)}
                </div>
              </div>
            </div>)}
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Link to="#">
            <Button size="lg" className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-14 text-lg font-bold shadow-xl transition-all hover:scale-105">
              Book an Appointment <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}